import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'
import MobileAddOnsForm from '../forms/MobileAddOnsForm'
import PaymentInformation from './PaymentInformation'
import ThingsToKnow from './ThingsToKnow'

const ManageMobileAddOns = (props) => {
    const [isLoaded, setIsLoaded] = useState(false)
    const [hasError, setHasError] = useState(false)
    const [addOns, setAddOns] = useState([])

    useEffect(() => {
        getAddOns()
    }, [props.serviceId])

    const getAddOns = () => {
        DataSource.getData(`/api/getMobileAddOns/${props.serviceId}`, result => {
            setIsLoaded(true)
            setAddOns(result)
        }, error => {
            setIsLoaded(true)
            setHasError(true)
        })
    }

    const handleSuccess = (response, state) => {
        // todo: Add event
        // globals.pushEvent('UpgradeToNbn', {speed: state.speed, allowance: state.allowance});
        props.updateServiceDetails(false)
    }

    return (
        <div>
            <div className='mobile-add-ons-module module' style={{ overflow: 'visible' }}>
                <div id='sub-navigation' />{/* This is for scrollToNav method in FormHOC */}
                <Heading title='Manage Add-ons' />
                <ModuleWithLoader isLoaded={isLoaded} hasError={hasError} className='p-4'>
                    <div className='row mb-4'>
                        <div className='col-12 col-lg-10 offset-lg-1 text-center'>
                            <p className='m-0 lh'>You can purchase additional data, additional non-included usage such as international calls and text by purchasing an Add-on here. Note that you can only have on Add-on of each type active at any given time. Data Add-ons are consumed before your recharge plan’s included data allowance.</p>
                        </div>
                    </div>
                    <MobileAddOnsForm serviceId={props.serviceId} addOns={addOns} handleSuccess={handleSuccess} />
                </ModuleWithLoader>
            </div>
            <PaymentInformation />
            <ThingsToKnow type='telstraAddOns' />
        </div>
    )
}

ManageMobileAddOns.propTypes = {
    serviceId: PropTypes.number.isRequired,
    serviceDetails: PropTypes.object.isRequired,
    updateServiceDetails: PropTypes.func.isRequired
}

export default ManageMobileAddOns



// WEBPACK FOOTER //
// ./resources/js/modules/ManageMobileAddOns.js